@if (!processes || processes?.length === 0) {
  <app-loading-and-no-data-template
    [isLoading]="!processes"
    [height]="380"
  ></app-loading-and-no-data-template>
} @else {
  <!--  to avoid including expanded data in .xlsx and .csv files-->
  <ng-container *ngTemplateOutlet="printTable"></ng-container>
  <div class="table-container">
    <!-- TODO: Remove after testing processes functionality on kpi module -->
    <table mat-table
      [dataSource]="dataSource"
      class="w-100 kpi-process-list-table px-2">
      @for (column of columnsToDisplay; track column; let last = $last; let i = $index) {
        <ng-container matColumnDef="{{column}}">
          <th mat-header-cell *matHeaderCellDef> {{last ? '' : (columnsToTranslate[i] | translate)}} </th>
          <td mat-cell *matCellDef="let element">
            @if (!last) {
              <ng-container
                [ngTemplateOutlet]="mainTableContent"
                [ngTemplateOutletContext]="{data: {i: i, element:element, column: column}}"
              ></ng-container>
            }
            @if (last && !element.total && showActions) {
              <div class="item-cell d-flex justify-content-end">
                <lib-select
                  [options]="optionsSelect"
                  [classes]="'text-primary text-left font-size-normal'"
                  [withIcon]="true"
                  [showCaret]="false"
                  [inactiveOptionClasses]="''"
                  (selectedChanged)="selectOption($event, element)">
                  <ng-container icon>
                    <i class="far fa-ellipsis-h font-icons pointer"></i>
                  </ng-container>
                </lib-select>
              </div>
            }
          </td>
        </ng-container>
      }
      <!-- TODO: Remove after testing processes functionality on kpi module
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
          @if (plannedEventsAndTClassBlocks) {
            <div class="example-element-detail"
              [class.expanded]="element == expandedElement">
              <ng-container
                [ngTemplateOutlet]="rowContent"
                [ngTemplateOutletContext]="{option: element}"
              ></ng-container>
            </div>
          }
        </td>
      </ng-container>
      -->
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"
        class="example-element-row"
        [ngClass]="{'last-row': !element.id}"
        >
      </tr>
      <!-- TODO: Remove after testing processes functionality on kpi module
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
      -->
    </table>
  </div>
}



<!-- TODO: Remove after testing processes functionality on kpi module
<ng-template #rowContent let-option=option>
  <mat-tab-group [(selectedIndex)]="selectedTabIndex" class="w-100">
    <mat-tab>
      <ng-template mat-tab-label>
        {{'KPI.PORTFOLIO.PROCESSES_LIST_TABLE.T_CLASS_BLOCKS' | translate}}
        <mat-chip
          class="rounded ml-2 font-size-small justify-content-center"
        >{{plannedEventsAndTClassBlocks?.tClassBlocks?.length}}</mat-chip>
      </ng-template>
      <app-kpi-t-class-blocks-list-table
        [tClassBlocks]="option === expandedElement ? plannedEventsAndTClassBlocks?.tClassBlocks : null"
        [displayActionColumn]="displayActionColumn"
        [isProcessUnassigning]="isProcessUnassigning"
        (optionSelected)="optionSelectedBlocksFunc($event)"
      ></app-kpi-t-class-blocks-list-table>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        {{'KPI.PORTFOLIO.PROCESSES_LIST_TABLE.PLANNED_EVENTS' | translate}}
        <mat-chip
          class="rounded ml-2 font-size-small justify-content-center"
        >{{plannedEventsAndTClassBlocks?.plannedEvents?.length}}</mat-chip>
      </ng-template>
      <app-kpi-planned-events-list-table
        [events]="option === expandedElement ? plannedEventsAndTClassBlocks?.plannedEvents : null"
        [displayActionColumn]="true"
        (optionSelected)="optionSelectedEventsFunc($event)"
      ></app-kpi-planned-events-list-table>
    </mat-tab>
  </mat-tab-group>
</ng-template>
-->

<ng-template #printTable>
  <div class="table-container hide">
    <table mat-table
      #periodBasedTable
      [dataSource]="dataSource"
      class="w-100">
      @for (column of columnsToDisplay; track column; let last = $last; let i = $index) {
        <ng-container matColumnDef="{{column}}">
          <th mat-header-cell *matHeaderCellDef> {{last ? '' : (columnsToTranslate[i] | translate)}} </th>
          <td mat-cell *matCellDef="let element">
            @if (!last) {
              <ng-container
                [ngTemplateOutlet]="mainTableContent"
                [ngTemplateOutletContext]="{data: {i: i, element:element, column: column}}"
              ></ng-container>
            }
          </td>
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"
        class="example-element-row"
        [ngClass]="{'last-row': !element.id}"
        >
        <!-- [class.example-expanded-row]="expandedElement === element" -->
      </tr>
    </table>
  </div>
</ng-template>


<ng-template #mainTableContent let-data="data">
  @if (data?.i === 0 && !data.element.total) {
    <div class="first-column item-cell"
      [matTooltip]="translateService.instant('PLANNING.TABLE.VIEW_PROCESS_DETAILS')"
      matTooltipPosition="above"
      [ngStyle]="{'border-left-color': data?.element.color, 'cursor': 'pointer'}"
      (click)="selectItem(data.element)">
      {{data?.element[data?.column]}}
    </div>
  }
  @if (data?.i === 0 && data.element.total) {
    <div class="item-cell">
      {{data?.element[data?.column]}}
    </div>
  }

  @if (data?.i === 1) {
    <div class="item-cell">
      {{data?.element[data?.column] | titlecase}}
    </div>
  }

  @if (data?.i === 2) {
    <div class="item-cell" style="white-space:nowrap">
      {{data?.element['estimatedStart'] > 0 ?
      ((data?.element['estimatedStart'] | dateTimeFormatPipe: 'dmy') + ' - ' + (data?.element['estimatedEnd']| dateTimeFormatPipe: 'dmy'))
      : ''}}
    </div>
  }

  @if (data?.i === 3) {
    <div class="item-cell"  [matTooltip]="data?.element[data?.column]| shortDuration">
      {{data?.element[data?.column] | duration:true:'seconds'}}
    </div>
  }

  @if (data?.i === 4) {
    <div class="item-cell"  [matTooltip]="data?.element[data?.column]| shortDuration">
      {{data?.element[data?.column] | duration:true:'seconds'}}
    </div>
  }

  @if (data?.i === 5) {
    <div class="item-cell"  [matTooltip]="data?.element[data?.column]| shortDuration" [ngStyle]="{'color': data?.element[data?.column] <= 0 ? 'var(--green)' : 'var(--red)'}">
      {{data?.element[data?.column] === 0 ? '' : data?.element[data?.column] < 0 ? '-' : '+'}} {{data?.element[data?.column] | duration:true:'seconds'}}
    </div>
  }

  @if (data?.i === 6) {
    <div class="item-cell">
      {{data?.element[data?.column] | number:'1.0-0' | customNumberFormat}} kWh
    </div>
  }

  @if (data?.i === 7) {
    <div class="item-cell">
      {{data?.element[data?.column] | number: '1.0-0' | customNumberFormat }} {{ ''|currencyPortfolio }}
    </div>
  }
</ng-template>


